/* eslint-disable no-param-reassign */
const notEmpty = (value: string): boolean => {
  value = typeof value === 'string' ? value.trim() : value;
  return Boolean(value);
};

const isEmpty = (value: string): boolean => !notEmpty(value);
const isAllDigits = (value: string): boolean => {
  value = typeof value === 'string' ? value.trim() : value;
  return /^\d+$/.test(value);
};

const isObjectEmpty = (value) => !(value && value === Object(value) && Object.keys(value).length !== 0);

const validateRoutingNumber = (routingNumber: string): boolean => {
  routingNumber = typeof routingNumber === 'string' ? routingNumber.trim() : routingNumber;
  if (isEmpty(routingNumber) || !isAllDigits(routingNumber) || routingNumber.length !== 9) {
    return false;
  }
  let sum = 0;
  for (let i = 0; i < routingNumber.length; i += 3) {
    sum +=
      parseInt(routingNumber.charAt(i), 10) * 3 +
      parseInt(routingNumber.charAt(i + 1), 10) * 7 +
      parseInt(routingNumber.charAt(i + 2), 10);
  }
  return sum !== 0 && sum % 10 === 0;
};

const validateCheckingAccount = (checkingAccountNumber: string): boolean => {
  checkingAccountNumber =
    typeof checkingAccountNumber === 'string' ? checkingAccountNumber.trim() : checkingAccountNumber;
  return notEmpty(checkingAccountNumber) && isAllDigits(checkingAccountNumber);
};

const validateZipCode = (zipCode: string): boolean => {
  zipCode = typeof zipCode === 'string' ? zipCode.trim() : zipCode;
  return notEmpty(zipCode) && isAllDigits(zipCode);
};

const validateLastFourSSN = (lastFourSSN: string): boolean => {
  lastFourSSN = typeof lastFourSSN === 'string' ? lastFourSSN.trim() : lastFourSSN;
  return notEmpty(lastFourSSN) && isAllDigits(lastFourSSN) && lastFourSSN.length === 4;
};

const validateFullSocialSecurityNumber = (fullSocialSecurityNumber: string): boolean => {
  fullSocialSecurityNumber =
    typeof fullSocialSecurityNumber === 'string' ? fullSocialSecurityNumber.trim() : fullSocialSecurityNumber;
  return (
    notEmpty(fullSocialSecurityNumber) && isAllDigits(fullSocialSecurityNumber) && fullSocialSecurityNumber.length === 9
  );
};

const validateEmployerIdentificationNumber = (employerIdentificationNumber: string): boolean => {
  employerIdentificationNumber =
    typeof employerIdentificationNumber === 'string'
      ? employerIdentificationNumber.trim()
      : employerIdentificationNumber;
  return (
    notEmpty(employerIdentificationNumber) &&
    isAllDigits(employerIdentificationNumber) &&
    employerIdentificationNumber.length === 9
  );
};

const validEmailAddress = (emailAddress: string): boolean =>
  /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(emailAddress);
const validSSN = (SSN: string) => {
  const ssnPattern = /^[0-9]{3}-?[0-9]{2}-?[0-9]{4}$/;
  return ssnPattern.test(SSN);
};

const validatePhoneNumber = (phoneNumber: string): boolean =>
  notEmpty(phoneNumber) && isAllDigits(phoneNumber) && phoneNumber.length === 10;

export {
  notEmpty,
  isEmpty,
  isAllDigits,
  isObjectEmpty,
  validateRoutingNumber,
  validateCheckingAccount,
  validateZipCode,
  validateLastFourSSN,
  validateFullSocialSecurityNumber,
  validateEmployerIdentificationNumber,
  validEmailAddress,
  validSSN,
  validatePhoneNumber,
};
